export default __webpack_public_path__ + "static/media/suicida.7c6c7c4b.png";